<template>
	<main class="h-100 w-100 d-flex justify-content-center align-items-center"> 
		<div class="container-fluid">
			<div class="row my-3">
				<div class="col-md-6 offset-md-3 col-sm-8 offset-sm-2 col-10 offset-1">
					<div class="card p-3">
						<ul>
							<li style="list-style: none;">
								¡Hola {{new_user?.first_name}}!<br><br> 
							</li>
							<li>
								Te has registrado con éxito. Se ha enviado un e-mail a {{new_user?.email}} para que confirmes tu registro.<br><br>
							</li>
							<li class="text-danger">
								Si no ves nuestro mensaje de confirmación de datos en tu bandeja de entrada revisa tu bandeja de SPAM o carpeta de Promociones de tu Gmail. Confirma que no sea spam y llévalo a tu bandeja principal.							</li>
							<li class="d-md-none">
								<p>
									Este producto está diseñado para aprender el teclado de un PC o portátil. No puedes ejecutar el programa en un teléfono móvil. Por favor busca tu correo de confirmación (enviado desde info@1hourlearning.com) y entra desde un PC o portátil.  
								</p>
								<br>
							</li>


							<li class="message text-dark font-weight-bold">
								<p>
									Muy importante: Este programa de aprendizaje es para aprender en el teclado normal de un PC o portátil. Lógicamente, no puedes aprenderlo en un móvil, sino sólo usarlo en un PC o portátil.<br>
								</p>
								<div class="row my-2">
									<div class="col-12">
										<p class="details">
											Aquí los datos de tu registro: 
										</p>
										<span>First Name: {{ new_user?.first_name}}</span><br>
										<span>Last Name: {{ new_user?.last_name}}</span><br>
										<span>Email: {{ new_user?.email}}</span>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</main>

</template>

<script>

import { onBeforeUnmount } from "vue";
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {

	name: "RegisterSuccess",
	setup(){
		const router = useRouter()

		const store = useStore();
		const new_user = store.getters.new_user;
		
		if(new_user.value == undefined ){
			router.push({name: 'Login'});
		}

		// onBeforeUnmount(() => {
		// 	store.dispatch("new_user", null);
		// });

		return { 
			new_user
		} 
	}
};
</script>

<style scoped>
    p {
        font-size: 12pt;
    }

    h1 {
        font-size: 20pt;
    }

    .content-container {
        display: block;
        width: 45vw;
    }

    .logo-container {
        padding-top: 100px;
    }

    .logo {
        background-color: transparent !important;
        color: turquoise !important;
        font-weight: bold;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
    }

    .logo:hover {
        box-shadow: 2px 4px 15px rgb(122, 201, 188);
    }

	#home-button{
		text-transform: uppercase;
		outline: 0;
		margin-top: -1em;
		background: #41e0d0;
		width: 100%;
		border: 0;
		padding: 15px;
		color: #FFFFFF;
		font-size: 14px;
		-webkit-transition: all 0.3 ease;
		transition: all 0.3 ease;
		cursor: pointer;
	}
	#home-button:hover{
		background: #34C9B8;
	}
	.none {
		display: none !important;
	}
	.message {
		margin: 15px 0 0;
		margin-bottom: 10px;
		color: #b3b3b3;
		font-size: 12px;
	}
</style>
